import { map } from 'rxjs';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { platformAPI } from '@services/API/endpoints';

@Injectable({
  providedIn: 'root',
})
export class CompanyApi {
  private http = inject(HttpClient)

  getCompanies() {
    const headers = new HttpHeaders({ 'Auth-Opt-In': 'true' });
    const params = new HttpParams().set('page', 1).set('size', 100);
    return this.http.get<any>(platformAPI.companies.list, { headers, params });
  }

  getAssetTypes() {
    const headers = new HttpHeaders({ 'Auth-Opt-In': 'true' });
    return this.http
      .get<any>(platformAPI.companies.catalogs.assetTypes, { headers })
      .pipe(map(res => res.asset_types));
  }

  getOperationTypes() {
    const headers = new HttpHeaders({ 'Auth-Opt-In': 'true' });
    return this.http
      .get<any>(platformAPI.companies.catalogs.operationTypes, { headers })
      .pipe(map(res => res.operation_types));
  }
}
